import { FunctionComponent, ReactElement, ReactNode } from "react";

import { CircularLoader } from "../../components/common";
import { SessionContext } from "../contexts";
import { useInitializeSession } from "../hooks";

export interface ISessionProviderProps {
    children?: ReactNode;
}

export const SessionProvider: FunctionComponent<ISessionProviderProps> = (
    props: ISessionProviderProps,
): ReactElement => {
    const { children } = props;
    const { session, expired, isLoading } = useInitializeSession();

    return (
        <SessionContext.Provider value={session}>
            {isLoading && <CircularLoader />}
            {session && !expired && children}
        </SessionContext.Provider>
    );
};
